import { Box, Toolbar } from "@mui/material"
import { Outlet } from "react-router-dom"
import AdminAppbar from "../appbar/AdminAppbar"
import AdminSidebar from "../../pages/admin/AdminSidebar"
import IdleTimeCount from "../common/IdleTimeCount"
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../redux/hooks"
import { setUserProfile } from "../../redux/slices/userSlice"
import { getUserProfile } from "../../services/UserService"
import { fetchAllMasterData } from "../../redux/slices/masterDataSlice"

const AdminLayout = () => {
  const dispatch = useAppDispatch()
  const { isLoggedIn } = useAppSelector((state) => state.user)

  useEffect(() => {
    if (!isLoggedIn) {
      return
    }

    async function getProfile() {
      const { data } = await getUserProfile()
      dispatch(setUserProfile(data?.user))
    }

    getProfile()
    dispatch(fetchAllMasterData())
  }, [isLoggedIn])

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <AdminAppbar />
        <AdminSidebar />
        <IdleTimeCount />
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <Toolbar />
          <Outlet />
        </Box>
      </Box>
    </>
  )
}

export default AdminLayout
